import { BarItemProps } from "@nivo/bar";
import { CORPORATE_FL_POPOVER_ID, DefaultTranslationFieldsInTable } from "constants/constants";
import { CorporateDashboardContext } from "contexts/CorporateDashboardContext/CorporateDashboardContext";
import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { translateDefaultEntity } from "utilities/localesUtilities";

const MachineCenterBarComponent: FC<BarItemProps<{ [key: string]: string | number }>> = (props) => {
    const {
        selectedMachineCenterPopoverData,
        handleSetSelectedMachineCenterPopoverData,
        selectedFailureCode,
    } = useContext(CorporateDashboardContext);
    const { t, i18n } = useTranslation();

    const openPopoverId = useMemo(
        () => (selectedMachineCenterPopoverData ? CORPORATE_FL_POPOVER_ID : undefined),
        [selectedMachineCenterPopoverData],
    );

    const handleClick = (event: React.MouseEvent<SVGGElement, MouseEvent>) => {
        const machineCenterId = Number(props.bar.data.data.numberId);
        const machineCenterName = String(props.bar.data.data.machineCenter);

        const failureCodeName =
            translateDefaultEntity(
                i18n.language,
                selectedFailureCode,
                "name",
                DefaultTranslationFieldsInTable.FAILURE_CODE,
            ) || "";

        const title = t("corporate_dashboard.downtime_by_failure_code_per_functional_location.title_modal", {
            failureCode: failureCodeName,
            machineCenter: machineCenterName,
        });

        handleSetSelectedMachineCenterPopoverData({
            machineCenterId,
            machineCenterName,
            barElement: event.currentTarget,
            title,
        });
    };

    return (
        <g
            aria-describedby={openPopoverId}
            transform={`translate(${props.bar.x}, ${props.bar.y})`}
            onClick={handleClick}
        >
            <rect width={props.bar.width} height={props.bar.height} fill={props.bar.color} />
        </g>
    );
};

export default MachineCenterBarComponent;
